var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hsp-layout',{scopedSlots:_vm._u([{key:"sidebar",fn:function(){return [_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"HSP","title":"HSP"}},[_c('template',{slot:"links"},[(!_vm.isUser)?_c('sidebar-item',{attrs:{"link":{
            name: 'Summary',
            icon: 'tim-icons icon-single-copy-04',
            path: {
              name: 'InstanceSummary',
              params: {
                surveyId: _vm.$route.params.surveyId,
                urlId: _vm.$route.params.urlId,
                routeFrom: _vm.$route.params.routeFrom
              }
            }
          }}}):_vm._e(),(_vm.isInternalAdmin)?_c('sidebar-item',{attrs:{"link":{
            name: 'Access',
            icon: 'tim-icons icon-badge',
            path: {
              name: 'InstanceAccess',
              params: {
                surveyId: _vm.$route.params.surveyId,
                urlId: _vm.$route.params.urlId,
                routeFrom: _vm.$route.params.routeFrom
              }
            }
          }}}):_vm._e(),(_vm.isInternalAdmin)?_c('sidebar-item',{attrs:{"link":{
            name: 'Data',
            icon: 'tim-icons icon-chart-bar-32',
            path: {
              name: 'InstanceReports',
              params: {
                surveyId: _vm.$route.params.surveyId,
                urlId: _vm.$route.params.urlId,
                routeFrom: _vm.$route.params.routeFrom
              }
            }
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: 'Dashboard',
            icon: 'tim-icons icon-chart-pie-36',
            path: {
              name: 'InstanceDashboard',
              params: {
                surveyId: _vm.$route.params.surveyId,
                urlId: _vm.$route.params.urlId,
                routeFrom: _vm.$route.params.routeFrom
              }
            }
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Reports',
            icon: 'tim-icons icon-cloud-download-93',
            path: {
              name: 'InstanceReportFiles',
              params: {
                surveyId: _vm.$route.params.surveyId,
                urlId: _vm.$route.params.urlId,
                routeFrom: _vm.$route.params.routeFrom
              }
            }
          }}})],1)],2)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }